module.exports = __webpack_public_path__ + "img/box-bai.a0597865.png";